import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import {
  AdditionalInfoReport,
  Export,
} from '@/domain/entities/AdditionalInfoReport'
import router from '@/router'
import Vue from 'vue'
import { AdditionalInfoReportPresenter } from '@/app/ui/presenters/AdditionalInfoReportPresenter'
import { AuthModule } from './auth'

export interface AdditionalInfoState {
  AdditionalInfoData: AdditionalInfoReport
  exportData: Export
  isLoading: boolean
  paginationParam: Object
}

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: 'AdditionalInfoReport',
})
class AdditionalInfos extends VuexModule implements AdditionalInfoState {
  public isLoading = true
  public isLoadingExport = true
  public AdditionalInfoData = new AdditionalInfoReport(true, '')
  public exportData = new Export(true, '')
  public paginationParam = {
    filter: {
      salescode: '',
      position: '',
      filecode: '',
      dealer: '',
      city: '',
      branch: '',
      start: '',
      end: '',
    },
  }
  public paginationParamsExport = {
    filter: {
      salescode: '',
      position: '',
      filecode: '',
      dealer: '',
      city: '',
      branch: '',
      start: '',
      end: '',
    },
  }

  @Action
  public async getAdditionalInfoData() {
    this.setLoading(true)
    const presenter = await container.resolve(AdditionalInfoReportPresenter)
    presenter
      .loadAdditionalInfoReport(this.paginationParam)
      .then((res: AdditionalInfoReport) => {
        this.setLoading(false)
        this.setAdditionalInfoData(res)
        // console.log('AdditionalInfo Data', res)
      })
      .catch((error) => {
        console.error('error', error)
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        this.setLoading(false)
      })
  }
  @Action
  public async getExportData() {
    this.setLoading(true)
    const presenter = await container.resolve(AdditionalInfoReportPresenter)
    presenter
      .loadExport(this.paginationParam)
      .then((res: Export) => {
        this.setExportData(res)
        //  console.log('export dataaa', res)
      })
      .catch((error) => {
        console.error('error', error)
      })
      .finally(() => {
        this.setLoadingExport(false)
      })
  }

  @Mutation
  private setAdditionalInfoData(AdditionalInfo: AdditionalInfoReport) {
    this.AdditionalInfoData = AdditionalInfo
  }
  @Mutation
  private setExportData(exp: Export) {
    this.exportData = exp
  }
  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }
  @Mutation
  private setLoadingExport(isLoadingExport: boolean) {
    this.isLoadingExport = isLoadingExport
  }
}

export const AdditionalInfoReportModule = getModule(AdditionalInfos)
